@for (config of configs; track config; let i = $index) {
  @if (!config.hidden) {
    <div
      class="FormGroup__control form--controls"
      [formGroup]="form"
      [style.grid-area]="config.grid | setGridPosition"
      [@fade]
      [@slideUp]
      [@.disabled]="!animate"
    >
      @if (!config.customFormElement) {
        @if (config.type === 'group') {
          @if (config.label) {
            <label class="form-control__label">
              <p class="t-bold">{{ config.label }}</p>
            </label>
          }
          <div class="FormGroup--nested">
            <form-group
              [style.display]="config.columns ? 'grid' : 'block'"
              [style.align-items]="'end'"
              [style.grid-template-columns]="formatGridColumns(config.columns)"
              [configs]="config.controls"
              [form]="form.get(config.prop)"
              [direction]="direction"
            >
            </form-group>
          </div>
        } @else {
          @if (!config.hideControl) {
            <form-control
              (linkClick)="linkClicked.emit({ config: config, event: $event })"
              (iconClick)="iconClicked.emit({ config: config, event: $event })"
              (selected)="selected.emit({ config: config, event: $event })"
              (iconRightClicked)="handleIconRightClicked()"
              (inputChanged)="
                inputChanged.emit({ config: config, event: $event })
              "
              (typeaheadInputCleared)="
                typeaheadClearClicked.emit({ config: config, event: $event })
              "
              (fileUploaded)="
                fileUploaded.emit({ config: config, event: $event })
              "
              (fileRemoved)="
                fileRemoved.emit({ config: config, event: $event })
              "
              (pendingAttachments)="
                pendingAttachments.emit({ config: config, event: $event })
              "
              [direction]="direction"
              [config]="config"
              [group]="form"
              [control]="form.controls[config.prop]"
              [disableEndpointOptions]="disableEndpointOptions"
              [selectedIndex]="getSelectedIndex(i)"
              [customEndpoint]="customEndpoint"
              [formControlOptionsParams]="formControlOptionsParams"
              [fileUploadInputs]="fileUploadInputs"
            >
            </form-control>
          }
        }
      } @else {
        @switch (config.type) {
          @case ('formGroupArray') {
            <form-group-array
              [group]="form"
              [config]="config"
              [context]="context"
            >
            </form-group-array>
          }
          @case ('optionalDate') {
            <optional-date
              [direction]="direction"
              [config]="config"
              [group]="form"
            >
            </optional-date>
          }
          @case ('conditionalToggle') {
            <conditional-toggle
              [formControlName]="config.prop"
              [parentForm]="form"
              [config]="config"
            >
              <form-group
                [configs]="config.controls"
                [form]="form"
                [ngClass]="{ 'conditional-grid': config.isGrid }"
              >
              </form-group>
            </conditional-toggle>
          }
          @case ('checkboxMatrix') {
            <checkbox-matrix
              [config]="config"
              [context]="context"
              [formGroup]="form"
            >
            </checkbox-matrix>
          }
          @case ('multiAddress') {
            <multi-address
              [config]="config"
              [context]="context"
              [formGroup]="form"
            >
            </multi-address>
          }
          @default {
            <custom-form-element
              (formCreated)="handleFormCreated($event, config)"
              [registeredComponents]="registeredComponents"
              [direction]="direction"
              [config]="config"
              [form]="form"
            >
            </custom-form-element>
          }
        }
      }
    </div>
    <ng-template #customFormElement>
      @switch (config.type) {
        @case ('formGroupArray') {
          <form-group-array
            [group]="form"
            [config]="config"
            [context]="context"
          >
          </form-group-array>
        }
        @case ('optionalDate') {
          <optional-date
            [direction]="direction"
            [config]="config"
            [group]="form"
          >
          </optional-date>
        }
        @case ('conditionalToggle') {
          <conditional-toggle
            [formControlName]="config.prop"
            [parentForm]="form"
            [config]="config"
          >
            <form-group
              [configs]="config.controls"
              [form]="form"
              [ngClass]="{ 'conditional-grid': config.isGrid }"
            >
            </form-group>
          </conditional-toggle>
        }
        @case ('checkboxMatrix') {
          <checkbox-matrix
            [config]="config"
            [context]="context"
            [formGroup]="form"
          >
          </checkbox-matrix>
        }
        @case ('multiAddress') {
          <multi-address
            [config]="config"
            [context]="context"
            [formGroup]="form"
          >
          </multi-address>
        }
        @default {
          <custom-form-element
            (formCreated)="handleFormCreated($event, config)"
            [registeredComponents]="registeredComponents"
            [direction]="direction"
            [config]="config"
            [form]="form"
          >
          </custom-form-element>
        }
      }
    </ng-template>
  }
}

@if (clear) {
  <zip-button
    [config]="clear"
    (zipButtonClicked)="clearForm()"
    [ariaDescription]="clear.isAriaDescriptionDisabled ? null : clear.content"
  >
  </zip-button>
}

@if (submit) {
  <zip-button
    [config]="submit"
    [disabled]="form.invalid"
    (zipButtonClicked)="submitForm()"
    [ariaDescription]="submit.isAriaDescriptionDisabled ? null : submit.content"
  >
  </zip-button>
}
